import React from 'react';

/** Lib Imports */
import PropTypes from 'prop-types';

/** CSS */
import "./NoRecordFound.scss";

const NoRecordFound = ({ message }) => {
    return (
        <div className="no-record-found" style={{ height: "100%" }}>
            <img src="/images/no-record-found.png" alt="No Record Found" />
            
            <p>{message || "No Record Found"}</p>
        </div>
    )
}

NoRecordFound.propTypes = {
    message: PropTypes.string.isRequired,
}

export default NoRecordFound;